import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../modules/Auth/login";
// import Register from "../modules/Auth/register";
import Dashboard from "../modules/Dashboard";
import CategoryList from "../modules/Category/CategoryList";
// import CategoryAdd from "../modules/Category/CategoryAddNew";
import CategoryEdit from "../modules/Category/CategoryEditNew";
// import SubCategoryList from "../modules/SubCategory/SubCategoryList";
import BlogList from "../modules/Blog/BlogList";
import BlogAdd from "../modules/Blog/BlogAddNew";
import BlogEdit from "../modules/Blog/BlogEditNew";
import TagList from "../modules/Tag/TagList";
import TagAdd from "../modules/Tag/TagAddNew";
import TagEdit from "../modules/Tag/TagEditNew";
import MarketAreaList from "../modules/MarketArea/MarketAreaList";
import GalleryList from "../modules/Gallery/GalleryList";
import GalleryAdd from "../modules/Gallery/GalleryAddNew";
import GalleryEdit from "../modules/Gallery/GalleryEditNew";
// import SettingList from "../modules/Settings/SettingList";
import TestimonialList from "../modules/Testimonial/TestimonialList";
import TestimonialAdd from "../modules/Testimonial/TestimonialAddNew";
import TestimonialEdit from "../modules/Testimonial/TestimonialEditNew";
import PartnerList from "../modules/Partner/PartnerList";
import PartnerAdd from "../modules/Partner/PartnerAddNew";
import PartnerEdit from "../modules/Partner/PartnerEditNew";
import TeamList from "../modules/Team/TeamList";
import TeamAdd from "../modules/Team/TeamAddNew";
import TeamEdit from "../modules/Team/TeamEditNew";
import InquiryList from "../modules/Inquiry/InquiryList";
import ProductList from "../modules/Product/ProductList";
import ProductAdd from "../modules/Product/ProductAddNew";
import ProductEdit from "../modules/Product/ProductEditNew";

import General from "../modules/Pages/GeneralList";
import CompanyDetail from "../modules/Pages/CompanyDetailsList";
import Domain from "../modules/Pages/DomainList";
import SocialLink from "../modules/Pages/SocialLinkList";
import Logo from "../modules/Pages/LogoList";
import Analytic from "../modules/Pages/AnalyticsList";
import HomePage from "../modules/Pages/HomePage/HomePageList";
import AboutUs from "../modules/Pages/HomePage/AboutUsList";
import PrivacyPolicy from "../modules/Pages/HomePage/PrivacyPolicyList";
import TermsAndConditions from "../modules/Pages/HomePage/TermsAndConditionsList";
import SeoConfiguration from "../modules/Pages/SeoConfigurationList";

import ChildCategoryList from "../modules/ChildCategory/ChildCategoryList";
import ChildCategoryEdit from "../modules/ChildCategory/ChildCategoryEditNew";

import GalleryCategoryAdd from "../modules/GalleryCategory/GalleryCategoryAddNew";
import GalleryCategoryEdit from "../modules/GalleryCategory/GalleryCategoryEditNew";
import GalleryCategoryList from "../modules/GalleryCategory/GalleryCategoryList";

import GalleryImageAdd from "../modules/GalleryImage/GalleryImageAddNew";
import GalleryImageEdit from "../modules/GalleryImage/GalleryImageEditNew";
import GalleryImageList from "../modules/GalleryImage/GalleryImageList";

import GalleryVideoAdd from "../modules/GalleryVideo/GalleryVideoAddNew";
import GalleryVideoEdit from "../modules/GalleryVideo/GalleryVideoEditNew";
import GalleryVideoList from "../modules/GalleryVideo/GalleryVideoList";

import PageList from "../modules/Page/PageList";
import PageAdd from "../modules/Page/PageAddNew";
import PageEdit from "../modules/Page/PageEditNew";
import PageView from "../modules/Page/PageView";

import FaqAdd from "../modules/FrequentlyAskedQuestion/FaqAddNew";
import FaqEdit from "../modules/FrequentlyAskedQuestion/FaqEditNew";
import FaqList from "../modules/FrequentlyAskedQuestion/FaqList";

import SubCategoryProductList from "../modules/SubCategoryProduct/SubCategoryProductList";
import SubCategoryProductAdd from "../modules/SubCategoryProduct/SubCategoryProductAddNew";
import SubCategoryProductEdit from "../modules/SubCategoryProduct/SubCategoryProductEditNew";
import NotFound from "../components/NotFound";

import CommonLayout from "../layouts";
import { AuthProvider } from "../context/AuthContext";
import { LoaderProvider } from "../context/LoaderContext";
import Loader from "../components/loader";
import PrivateRouteLayout from './PrivateRouteLayout';
import ColorManagerCard from "../modules/ThemeConfiguration/ColorCardManager";

const AppRoutes = () => (
  <AuthProvider>
    <LoaderProvider>
      <Loader />
      <Router>
        <Routes>
          <Route exact path="/login" element={<Login />} />
          {/* <Route exact path="/register" element={<Register />} /> */}
            <Route path="/" element={<PrivateRouteLayout />}>
              <Route path="/" element={<CommonLayout />}>
                <Route exact path="/" element={<Dashboard />} />
                <Route exact path="/blogs" element={<BlogList />} />
                <Route exact path="/blog-add" element={<BlogAdd />} />
                <Route exact path="/blog-edit/:id" element={<BlogEdit />} />
                {/* <Route exact path="/blog-add" element={<BlogList />} /> */}
                <Route exact path="/tags" element={<TagList />} />
                <Route exact path="/tag-add" element={<TagAdd />} />
                <Route exact path="/tag-edit/:id" element={<TagEdit />} />
                <Route exact path="/target-regions" element={<MarketAreaList />} />
                <Route exact path="/galleries" element={<GalleryList />} />
                <Route exact path="/gallery-add" element={<GalleryAdd />} />
                <Route exact path="/gallery-edit/:id" element={<GalleryEdit />} />
                {/* <Route exact path="/settings" element={<SettingList />} /> */}
                <Route exact path="/categories" element={<CategoryList />} />
                {/* <Route exact path="/category-add" element={<CategoryAdd />} /> */}
                <Route exact path="/category-edit/:id" element={<CategoryEdit />} />
                {/* <Route exact path="/sub-categories" element={<SubCategoryList />} /> */}
                <Route exact path="/testimonials" element={<TestimonialList />} />
                <Route exact path="/testimonial-add" element={<TestimonialAdd />} />
                <Route exact path="/testimonial-edit/:id" element={<TestimonialEdit />} />
                <Route exact path="/teams" element={<TeamList />} />
                <Route exact path="/team-add" element={<TeamAdd />} />
                <Route exact path="/team-edit/:id" element={<TeamEdit />} />
                <Route exact path="/inquiries" element={<InquiryList />} />
                <Route exact path="/products" element={<ProductList />} />
                <Route exact path="/product-add" element={<ProductAdd />} />
                <Route exact path="/product-edit/:id" element={<ProductEdit />} />
                <Route exact path="/" element={<Dashboard />} />
                <Route exact path="/clients" element={<PartnerList />} />
                <Route exact path="/client-add" element={<PartnerAdd />} />
                <Route exact path="/client-edit/:id" element={<PartnerEdit />} />

                <Route exact path="/general" element={<General />} />
                <Route exact path="/company-details" element={<CompanyDetail />} />
                <Route exact path="/domain" element={<Domain />} />
                <Route exact path="/social-links" element={<SocialLink />} />
                <Route exact path="/logo" element={<Logo/>} />
                <Route exact path="/google-analytics" element={<Analytic />} />
                <Route exact path="/home-page" element={<HomePage />} />
                <Route exact path="/about-us" element={<AboutUs />} />
                <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route exact path="/terms-conditions" element={<TermsAndConditions />} />
                <Route exact path="/seo-configuration" element={<SeoConfiguration />} />

                <Route exact path="/child-categories/:id" element={<ChildCategoryList />} />
                <Route exact path="/child-category-edit/:id" element={<ChildCategoryEdit />} />

                <Route exact path="/gallery-categories" element={<GalleryCategoryList />} />
                <Route exact path="/gallery-category-add" element={<GalleryCategoryAdd />} />
                <Route exact path="/gallery-category-edit/:id" element={<GalleryCategoryEdit />} />

                <Route exact path="/gallery-images" element={<GalleryImageList />} />
                <Route exact path="/gallery-image-add" element={<GalleryImageAdd />} />
                <Route exact path="/gallery-image-edit/:id" element={<GalleryImageEdit />} />

                <Route exact path="/gallery-videos" element={<GalleryVideoList />} />
                <Route exact path="/gallery-video-add" element={<GalleryVideoAdd />} />
                <Route exact path="/gallery-video-edit/:id" element={<GalleryVideoEdit />} />

                <Route exact path="/pages" element={<PageList />} />
                <Route exact path="/Page-add" element={<PageAdd />} />
                <Route exact path="/Page-edit/:id" element={<PageEdit />} />
                <Route exact path="/page/:id" element={<PageView />} />

                <Route exact path="/faqs" element={<FaqList />} />
                <Route exact path="/faq-add" element={<FaqAdd />} />
                <Route exact path="/faq-edit/:id" element={<FaqEdit />} />

                <Route exact path="/sub-category-products/:id" element={<SubCategoryProductList />} />
                <Route exact path="/sub-category-product-add/:id" element={<SubCategoryProductAdd />} />
                <Route exact path="/sub-category-product-edit/:id" element={<SubCategoryProductEdit />} />
                <Route exact path="/color-configuration" element={<ColorManagerCard />}
              />

                <Route path="*" element={<NotFound />} />
                
              </Route>
          </Route>
        </Routes>
      </Router>
    </LoaderProvider>
  </AuthProvider>
);

export default AppRoutes;
